import {Component, OnInit} from '@angular/core';
import {QuestionComponentBase} from "../../../../../model/QuestionComponentBase";
import {PlaceholderAnswer, V3Audio, V3AudioAnswerHolder} from "../../../../model/v3/cspa";
import {QuestionService} from "../../../../services/api/impl/rest/question.service";
import {LogsService} from "../../../../../utils/services/logs.service";
import {AuthorizationServiceProvider} from "../../../../../auth_profile/services/authorization-service.provider";
import {environment} from "../../../../../../environments/environment";
import {QuestionActionRequest, QuestionActionRequestWithAnimation, QuestionActionRequestWithValue} from "../../../../../model/prototypes";
import {Subscription} from "rxjs";
import {ShortcutService} from "../../../../services/shortcut.service";

class TokenAnswer {
  constructor(public content: string) {}
}

@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss'],
    standalone: false
})
export class AudioComponent extends QuestionComponentBase<V3AudioAnswerHolder, V3Audio> implements OnInit {

  questionAnswers: TokenAnswer[];
  selectedAnswer: TokenAnswer
  audio= new Audio()
  qaRequestStartPulsating: (QuestionActionRequestWithAnimation | QuestionActionRequestWithValue)[] = [
    {
      text: 'play',
      assetUrl: 'play-arrow-filled',
      animation: 'pulsating'
    }
  ]
  qaRequestStartNoPulsating: (QuestionActionRequestWithAnimation | QuestionActionRequestWithValue)[] = [
    {
      text: 'play',
      assetUrl: 'play-arrow-filled',
      animation: 'none'
    }
  ]
  qaRequestStop: (QuestionActionRequest | QuestionActionRequestWithValue)[] = [
    {
      text: 'stop',
      assetUrl: 'play-arrow-disabled'
    }
  ]
  disableAnswerButton: boolean
  private shortcutButtonSubscription: Subscription;

  constructor(private questionService: QuestionService,
              logs: LogsService,
              private shortcut: ShortcutService,
              authProvider: AuthorizationServiceProvider) {
    super(logs, authProvider);
  }

  ngOnInit(): void {
    this.sendRequest(this.qaRequestStartPulsating)
    this.prepareQuestionTokens()
    this.inProgressEmitter.emit(true)
    this.questionSubscription = this.questionService.answerRequest.subscribe(sendAnswer =>
      sendAnswer &&
      sendAnswer['answerType'] === 'V3Audio' &&
      sendAnswer['getNewAnswer'] === true &&
      this.getAnswerForSubmit()
    )
    this.shortcutButtonSubscription = this.shortcut.btnRequest.subscribe(btn => {
      btn === 'play' && this.play()
      btn === 'pause' && this.stop()
    })
    this.disableAnswerButton = true
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.stop()
    if (this.shortcutButtonSubscription) this.shortcutButtonSubscription.unsubscribe()

  }

  isButtonDisabled(){
    return this.disableAnswerButton
  }

  sendRequest(audioRequest: QuestionActionRequest[]) {
    this.updateActionMenu.emit(audioRequest)
  }

  getAnswerForSubmit() {
    this.mapTokensOnAnswers();
    this.sendAnswer()
  }

  mapTokensOnAnswers() {
    if (!this.questionAnswers) {
      return;
    }

    this.answer.answer = [];
    this.answer.answer = [{
      name: "1",
      val: [this.selectedAnswer.content],
      alt: [],
    } as PlaceholderAnswer];
  }

  setUpAnswer(answer: V3AudioAnswerHolder) {
    if (answer?.answer) {
      this.answer = answer;
    } else {
      this.answer = { answer: [] };
    }
    this.mapAnswerOnTokens();
  }

  getContent(token: any) {
    return token.content
  }

  mapAnswerOnTokens() {
    if (!this.questionAnswers || !this.answer) {
      return;
    }

    this.answer.answer
      .filter(ae => ae.name && ae.val && ae.val.length === 1)
      .forEach( ae => {
        const targetAnswer = this.questionAnswers.find( qa => qa.content === ae.val[0]);
        if (!targetAnswer) {
          return;
        }
        this.assignAnswer(targetAnswer);
      });
  }

  assignAnswer(tokenAnswer: any) {
    this.selectedAnswer = tokenAnswer
    this.inProgressEmitter.emit(false)
  }

  getAudioSrc() {
    const questionDef = this.question.questionDef as V3Audio
    return environment.awsBase + questionDef.audio + ".mp3";
  }

  prepareQuestionTokens(): void {
    const questionDef = this.question.questionDef as V3Audio
    this.questionAnswers = questionDef.answers
      .map( answer => new TokenAnswer(answer));

    this.mapAnswerOnTokens();
  }

  play() {
    (<QuestionActionRequestWithValue>this.qaRequestStartNoPulsating[0]).value = this.audio.volume * 100;
    (<QuestionActionRequestWithValue>this.qaRequestStop[0]).value = this.audio.volume * 100
    this.sendRequest(this.qaRequestStop)
    this.audio.src = this.getAudioSrc();
    this.audio.onended = () => {
      this.sendRequest(this.qaRequestStop)
      this.disableAnswerButton = false
    };
    this.audio.load();
    this.audio.play().then(
      null,
      () => this.sendRequest(this.qaRequestStartNoPulsating)
    );
  }

  stop() {
    this.sendRequest(this.qaRequestStartNoPulsating)
    this.audio.pause()
  }
}
